import { Axios } from 'commonUtils';

const publicEndpoint = '/api/projectAccessRequests';
const endpoint = '/spr/projectAccessRequests';

export default class ProjectAccessRequestApi {
  async findPendingRequests({ email, projectId }) {
    return await Axios.getData(`${projectId ? endpoint : publicEndpoint}/pending`, {
      params: {
        email,
        projectId,
      },
    });
  }

  async requestAccess({ projectIds = [], email = '' }) {
    return await Axios.postData(`${publicEndpoint}/requestAccess`, { projectIds, email });
  }

  async answerRequests(answers = []) {
    return await Axios.postData(`${endpoint}/answer`, { answers });
  }
}
